module.exports = "<div>\n    <gw-pl-input-ctrl ng-if=\"isFieldVisible('Name')\" readonly=\"readonly\" model=\"contact.contactName\"\n                      label=\"{{'platform.inputs.company-details.Name' | translate }}\"></gw-pl-input-ctrl>\n    <gw-pl-input-ctrl ng-if=\"isFieldVisible('NameKanji')\" readonly=\"readonly\" model=\"contact.contactNameKanji\"\n                      label=\"{{'platform.inputs.contact-details.Name Kanji' | translate }}\"></gw-pl-input-ctrl>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/inputs/templates/companyname-details-JP.html
// module id = 754
// module chunks = 0